export default __webpack_public_path__ + "static/MeshMate-of-the-Year-2021-Aditya-Chatterjee-62b6a0dcadf601027b32ea16f97c2c02.webp";